import type { Reducer } from 'react'

import {
  getInitialState as getCategoryInitialState,
  InitialStateProps as CategoryInitialStateProps,
  reducer as categoryReducer,
} from '../../../reusable/Category/state'
import { SecondTryAction } from '../typings/SecondTryAction'
import { SecondTryState } from '../typings/SecondTryState'

interface InitialStateProps extends CategoryInitialStateProps {}

export const getInitialState = (props: InitialStateProps): SecondTryState => {
  return {
    categoryState: getCategoryInitialState(props),
    introData: {},
    recommendedApps: [],
    selectedAppDefIds: [],
    isRecommendedAppsLoading: false,
    businessName: '',
  }
}

export const reducer: Reducer<SecondTryState, SecondTryAction> = (state, action) => {
  if (action.type === 'setIntroData') {
    return {
      ...state,
      introData: action.introData,
    }
  }

  if (action.type === 'loadRecommendedAppsStart') {
    return {
      ...state,
      isRecommendedAppsLoading: true,
    }
  }

  if (action.type === 'loadRecommendedAppsSuccess') {
    return {
      ...state,
      isRecommendedAppsLoading: false,
      recommendedApps: action.apps,
    }
  }

  if (action.type === 'setSelectedAppDefIds') {
    return {
      ...state,
      selectedAppDefIds: action.appDefIds,
    }
  }

  if (action.type === 'setBusinessName') {
    return {
      ...state,
      businessName: action.businessName,
    }
  }

  const categoryState = categoryReducer(state.categoryState, action)

  return {
    ...state,
    categoryState,
  }
}
